const fetchCustomerData = (customerId) => {

    const param = `?customer_id=${customerId}`;
    const endpoint = '/apps/siggi/companies/company-contact';

    fetch(`${endpoint}${param}`)
        .then((response) => response.json())
        .then((data) => {
            if (data.area_manager_name) {
                window.sgg_accountUserData.area_manager_email = data.area_manager_email;
                window.sgg_accountUserData.area_manager_name = data.area_manager_name;
                accountData = window.sgg_accountUserData;
                sessionStorage.setItem('accountData', JSON.stringify(window.sgg_accountUserData));
                const accountEvent = new Event("updatedAccountData");
                document.dispatchEvent(accountEvent);
            }
        });
}

let accountData = sessionStorage.getItem('accountData');

if (!accountData || !accountData.area_manager_email || !accountData.area_manager_name) {
    if (!window.sgg_accountUserData.id) {
        document.addEventListener('load', () => {
            fetchCustomerData(window.sgg_accountUserData.id);
        });
    } else {
        fetchCustomerData(window.sgg_accountUserData.id);
    }
}

document.addEventListener('updatedAccountData', () => {
    document.querySelector('#area-manager-name').innerText = accountData.area_manager_name ?? "N/D";
});

